"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HighlightsList;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));
var _List = _interopRequireDefault(require("@material-ui/core/List"));
var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));
var _Create = _interopRequireDefault(require("@material-ui/icons/Create"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _FileCopy = _interopRequireDefault(require("@material-ui/icons/FileCopy"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _ColorLens = _interopRequireDefault(require("@material-ui/icons/ColorLens"));
var _themes = require("../../themes");
var _styles = _interopRequireDefault(require("./styles"));
var _DeleteHighlightModal = _interopRequireDefault(require("../DeleteHighlightModal"));
var _contexts = require("../../contexts");
var _services = require("../../services");
var _utils = require("../../utils");
var _ColorPopover = _interopRequireDefault(require("../ColorPopover"));
var _copy = require("../../constants/copy");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /*
  eslint-disable
  react/jsx-props-no-spreading, operator-linebreak, react/jsx-wrap-multilines, react/jsx-no-bind
*/ // Styles
// Components
// Contexts
// Services
function Highlight(props) {
  var textRef = (0, _react.useRef)();
  var {
    highlight,
    deleteHighlight: _deleteHighlight,
    containerRef,
    inputRef,
    setSelectedHighlight
  } = props;
  var classes = (0, _styles.default)();
  var {
    jumpToPage,
    getChapterName,
    sessionToken,
    uuid,
    bookTitle,
    rendition
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var {
    updateColor
  } = (0, _react.useContext)(_contexts.HighlightsContext);
  var {
    isCopyrightWarnDisable,
    setOpenCopyrightDialog,
    setOpenCopyTextDialog,
    setOpenCopyrightLimitDialog,
    setReference,
    setCopyValue,
    getPercentageCharsCopied,
    setCopyOrigin
  } = (0, _react.useContext)(_contexts.CopyrightContext);
  var {
    isDesktopView,
    setOpenDrawer,
    setOnHashChangeCallback
  } = (0, _react.useContext)(_contexts.SideBarContext);
  var {
    updateHighlightAnnotation,
    repaintHighlight
  } = (0, _react.useContext)(_contexts.HighlightsContext);
  var [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  var [deleteModalIsOpen, setDeleteModalOpen] = (0, _react.useState)(false);
  var handleItemClick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* () {
      yield jumpToPage(highlight.textReference);
      if (!isDesktopView) setOpenDrawer(false);
      repaintHighlight(rendition);
    });
    return function handleItemClick() {
      return _ref.apply(this, arguments);
    };
  }();
  var appToken = (0, _utils.appTokenCase)(window.location.origin);
  var service = (0, _services.TrackingsService)(appToken, sessionToken);
  var chapterName = getChapterName(highlight.textReference) || bookTitle;
  var [value, setValue] = (0, _react.useState)(highlight.annotation || '');
  var [showSaveButton, setShowSaveButton] = (0, _react.useState)(false);
  var [textSaved, setTextSaved] = (0, _react.useState)(!!highlight.annotation);
  var [textEdit, setTextEdit] = (0, _react.useState)(!highlight.annotation);
  var handleChangeValue = e => {
    setValue(e.target.value);
    setShowSaveButton(true);
  };
  var handleSubmitAnnotation = () => {
    updateHighlightAnnotation(highlight.id, {
      annotation: value
    });
    setShowSaveButton(false);
    setTextSaved(true);
    if (value === '') {
      setTextSaved(false);
    }
  };
  var handleBlurEvent = () => {
    updateHighlightAnnotation(highlight.id, {
      annotation: value
    });
    setTextEdit(false);
    setTextSaved(false);
    if (value) {
      setTextSaved(true);
    }
    setTimeout(() => {
      setShowSaveButton(false);
    }, 150);
  };
  var handleClick = event => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  var handleClose = event => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(null);
  };
  var saveButton = /*#__PURE__*/_react.default.createElement(_saraivaUi.Button, {
    className: classes.noteButtons,
    color: "primary",
    onClick: handleSubmitAnnotation
  }, "Salvar");
  function handleOnClick() {
    if (!textSaved || textEdit) {
      service.trackAddBooknote({
        uuid,
        titleCover: bookTitle,
        origin: 'clicou no Textfield Adicionar Nota',
        color: highlight.color,
        booknote: value ? 'yes' : 'no',
        id: highlight.id,
        highlight: highlight.textHighlighted
      });
    } else {
      setTextEdit(true);
      service.trackEditHighlight({
        uuid,
        titleCover: bookTitle,
        origin: 'Clique no TextField',
        highlight: highlight.id,
        booknote: value ? 'yes' : 'no'
      });
    }
  }
  function handleOnFocus() {
    var input = document.getElementById(highlight.textReference);
    var inputLength = input.value.length * 2;
    input.focus();
    input.setSelectionRange(inputLength, inputLength);
    setShowSaveButton(true);
  }
  function onUpdateColor(color) {
    updateColor(highlight, color);
    setAnchorEl();
  }
  function renderUpdateColorForDesktop() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.menuItemCascade
    }, /*#__PURE__*/_react.default.createElement(_saraivaUi.MenuItem, {
      cascade: true,
      label: "Alterar cor",
      icon: /*#__PURE__*/_react.default.createElement(_ColorLens.default, {
        className: classes.iconMenuPopover
      }),
      className: "".concat(classes.popup, " ").concat(classes.popupDesktop)
    }, highlight.color !== _themes.COLORS.GREEN && /*#__PURE__*/_react.default.createElement(_saraivaUi.MenuItem, {
      onClick: () => onUpdateColor(_themes.COLORS.GREEN)
    }, "Verde"), highlight.color !== _themes.COLORS.YELLOW && /*#__PURE__*/_react.default.createElement(_saraivaUi.MenuItem, {
      onClick: () => onUpdateColor(_themes.COLORS.YELLOW)
    }, "Amarelo"), highlight.color !== _themes.COLORS.RED && /*#__PURE__*/_react.default.createElement(_saraivaUi.MenuItem, {
      onClick: () => onUpdateColor(_themes.COLORS.RED)
    }, "Vermelho"), highlight.color !== _themes.COLORS.PURPLE && /*#__PURE__*/_react.default.createElement(_saraivaUi.MenuItem, {
      onClick: () => onUpdateColor(_themes.COLORS.PURPLE)
    }, "Roxo")));
  }
  function onSelectColorForUpdate() {
    setSelectedHighlight(highlight);
    setAnchorEl();
  }
  function renderUpdateColorForResponsive() {
    return /*#__PURE__*/_react.default.createElement(_saraivaUi.MenuItem, {
      onClick: onSelectColorForUpdate
    }, /*#__PURE__*/_react.default.createElement(_ColorLens.default, {
      className: classes.iconPopover
    }), "Alterar cor");
  }
  function onInputRef(el) {
    inputRef(el);
    textRef.current = el;
  }
  function renderTextField() {
    var isFocused = !textSaved || textEdit;
    return /*#__PURE__*/_react.default.createElement(_TextField.default, {
      id: highlight.textReference,
      label: isFocused && 'Adicionar nota',
      multiline: true,
      rowsMax: 4,
      value: value,
      variant: "outlined",
      fullWidth: true,
      onClick: handleOnClick,
      onChange: handleChangeValue,
      onFocus: handleOnFocus,
      onBlur: handleBlurEvent,
      inputRef: onInputRef,
      className: !isFocused ? classes.savedTextField : ''
    });
  }
  function onEditNote(evt) {
    handleClose(evt);
    textRef.current.focus();
    textRef.current.click();
    service.trackEditHighlight({
      uuid,
      titleCover: bookTitle,
      origin: 'clicou no Dropdown de Edição',
      highlight: highlight.id,
      booknote: value ? 'yes' : 'no'
    });
  }
  function openCopyDialog() {
    return _openCopyDialog.apply(this, arguments);
  }
  function _openCopyDialog() {
    _openCopyDialog = _asyncToGenerator(function* () {
      var checkCopyright = yield isCopyrightWarnDisable();
      var copyValue = yield getPercentageCharsCopied();
      setCopyValue(copyValue);
      if (copyValue >= 100) {
        setOpenCopyrightLimitDialog(true);
      } else if (checkCopyright && copyValue < 100) {
        setOpenCopyTextDialog(true);
      } else if (!checkCopyright && copyValue < 100) {
        setOpenCopyrightDialog(true);
      }
    });
    return _openCopyDialog.apply(this, arguments);
  }
  function onCopyHighlight(event) {
    handleClose(event);
    setOpenDrawer(false);
    setCopyOrigin(_copy.ORIGIN.HIGHLIGHT);
    setReference(highlight.textHighlighted);
    jumpToPage(highlight.textReference);
    setOnHashChangeCallback(() => openCopyDialog);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: containerRef
  }, /*#__PURE__*/_react.default.createElement(_DeleteHighlightModal.default, {
    deleteHighlight: () => {
      _deleteHighlight(highlight);
      setDeleteModalOpen(false);
    },
    open: deleteModalIsOpen,
    handleClose: () => setDeleteModalOpen(false)
  }), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    "aria-label": "settings",
    "aria-haspopup": "true",
    "aria-controls": "simple-menu",
    onClick: handleClick,
    className: classes.iconMenu
  }, /*#__PURE__*/_react.default.createElement(_MoreVert.default, {
    className: classes.icon
  })), /*#__PURE__*/_react.default.createElement(_saraivaUi.Menu, {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose,
    className: classes.popup,
    placement: "bottom-end"
  }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    onClick: onCopyHighlight
  }, /*#__PURE__*/_react.default.createElement(_FileCopy.default, {
    className: classes.iconPopover
  }), "Copiar"), /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    onClick: onEditNote
  }, /*#__PURE__*/_react.default.createElement(_Create.default, {
    className: classes.iconPopover
  }), "Editar nota"), (0, _utils.getDeviceType)() === 'desktop' ? renderUpdateColorForDesktop() : renderUpdateColorForResponsive(), /*#__PURE__*/_react.default.createElement(_Divider.default, {
    className: classes.menuItemDivider
  }), /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    onClick: (/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (evt) {
        handleClose(evt);
        setDeleteModalOpen(true);
        service.trackEditHighlight({
          uuid,
          titleCover: bookTitle,
          origin: 'clicou para excluir nota',
          highlight: highlight.id,
          booknote: value ? 'yes' : 'no'
        });
      });
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }())
  }, /*#__PURE__*/_react.default.createElement(_Delete.default, {
    className: classes.iconPopover
  }), "Excluir")), /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
    primary: chapterName,
    secondary: "P\xE1gina ".concat(rendition.book.locations.locationFromCfi(highlight.textReference)),
    className: classes.chapterTitleInHighlight
  }), /*#__PURE__*/_react.default.createElement(_ListItem.default, {
    key: highlight.id,
    onClick: handleItemClick,
    button: true
  }, /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
    primary: highlight.textHighlighted,
    style: {
      backgroundColor: _themes.HIGHLIGHT_COLORS[highlight.color]
    },
    className: classes.textHighlighted
  })), /*#__PURE__*/_react.default.createElement(_ListItem.default, {
    classes: {
      root: classes.textField
    }
  }, renderTextField()), showSaveButton && saveButton, /*#__PURE__*/_react.default.createElement(_Divider.default, {
    className: showSaveButton ? classes.noteDivider : null
  }));
}
function HighlightsList() {
  var [colorHighlight, setColorHighlight] = (0, _react.useState)();
  var {
    highlightsState,
    deleteHighlight,
    updateColor
  } = (0, _react.useContext)(_contexts.HighlightsContext);
  var {
    selectedAnnotation
  } = (0, _react.useContext)(_contexts.SideBarContext);
  var _containerRef = (0, _react.useRef)({});
  var _inputRef = (0, _react.useRef)({});
  var classes = (0, _styles.default)();
  (0, _react.useEffect)(() => {
    var input = _inputRef.current[selectedAnnotation === null || selectedAnnotation === void 0 ? void 0 : selectedAnnotation.cfiRange];
    var container = _containerRef.current[selectedAnnotation === null || selectedAnnotation === void 0 ? void 0 : selectedAnnotation.cfiRange];
    container === null || container === void 0 || container.scrollIntoView({
      behavior: 'auto',
      block: 'center',
      inline: 'center'
    });
    input === null || input === void 0 || input.focus();
    input === null || input === void 0 || input.click();
  }, [selectedAnnotation]);
  if (highlightsState.length === 0) {
    return /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2",
      classes: {
        root: classes.placeholder
      }
    }, "Selecione uma parte do texto para fazer um destaque ou uma nota.");
  }
  function handleHighlightRef(ref, el, highlight) {
    ref.current = _objectSpread(_objectSpread({}, ref.current), {}, {
      [highlight.textReference]: el
    });
  }
  function onChangeColor(highlight, color) {
    updateColor(highlight, color);
    setColorHighlight();
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_List.default, {
    component: "nav",
    className: classes.root
  }, highlightsState.map(highlight => /*#__PURE__*/_react.default.createElement(Highlight, {
    highlight: highlight,
    deleteHighlight: deleteHighlight,
    key: highlight.id,
    containerRef: el => handleHighlightRef(_containerRef, el, highlight),
    inputRef: el => handleHighlightRef(_inputRef, el, highlight),
    setSelectedHighlight: setColorHighlight
  }))), /*#__PURE__*/_react.default.createElement(_ColorPopover.default, {
    open: Boolean(colorHighlight),
    highlight: colorHighlight,
    onChangeColor: onChangeColor,
    onClose: () => setColorHighlight()
  }));
}
Highlight.propTypes = {
  deleteHighlight: _propTypes.default.func.isRequired,
  highlight: _propTypes.default.shape({
    id: _propTypes.default.number.isRequired,
    textHighlighted: _propTypes.default.string.isRequired,
    textReference: _propTypes.default.string.isRequired,
    annotation: _propTypes.default.string,
    color: _propTypes.default.string
  }).isRequired,
  inputRef: _propTypes.default.func.isRequired,
  containerRef: _propTypes.default.func.isRequired,
  setSelectedHighlight: _propTypes.default.func.isRequired
};